module.exports = __webpack_public_path__ + "img/services-stripes-left.dcc3997a.png";